export default "__VITE_ASSET__86d3c49c__"